/**
 * 系统管理 菜单管理
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item style="margin-top: 20px;">菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <el-row>
      <!-- title -->
      <!-- <div class="modt-box">用户管理</div> -->
      <div class="modt-box"></div>
      <el-col :span="4"> </el-col>
      <el-col :span="6">
        <div class="mod-btnbox">
          <!-- <el-button size="small" type="primary">全部展开</el-button>
          <el-button size="small" type="primary">全部压缩</el-button> -->
        </div>
        <el-tree class="treeclass" 
                  ref="tree" 
                  :data="treeData" 
                  default-expand-all="" 
                  :props="defaultProps"
                  @node-click="nodeclick" 
                  node-key="id">
        </el-tree>
      </el-col>
      <el-col :span="18">
        <div class="mod-btnbox">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addModule">添加</el-button>
        </div>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="父级菜单" prop="pid">
            <el-select size="small" v-model="form.pid" placeholder="请选择" class="selectw">
              <el-option v-for="parm in fmenu" :key="parm.id" :label="parm.name" :value="parm.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜单名称" prop="moduleName">
            <el-input size="small" v-model="form.moduleName"></el-input>
          </el-form-item>
          <el-form-item label="菜单别称" prop="moduleAlias">
            <el-input size="small" v-model="form.moduleAlias"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="moduleIcon">
            <el-input size="small" v-model="form.moduleIcon"></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="moduleUrl">
            <el-input size="small" v-model="form.moduleUrl"></el-input>
          </el-form-item>
          <el-form-item label="顺序" prop="sort">
            <el-input size="small" v-model="form.sort"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="saveModule('form')">保存</el-button>
            <el-button size="small" type="danger" v-show="showdelete" @click="deleteModule">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  ModuleList,
  ModuleGet,
  ModuleNodes,
  ModuleSave,
  ModuleDelete
} from '../../api/userMG'
export default {
  data() {
    return {
      showdelete: true,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      form: {
        id: '',
        pid: '',
        moduleName: '',
        moduleUrl: '',
        moduleIcon: '',
        sort: '',
        moduleAlias: ''
      },
      // rules表单验证
      rules: {
        pid: [
          { required: true, message: '请选择父级菜单', trigger: 'blur' }
        ],
        moduleName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        moduleAlias: [
          { required: true, message: '请输入菜单别称', trigger: 'blur' }
        ],
        moduleIcon: [
          { required: true, message: '请输入菜单图标', trigger: 'blur' }
        ],
        moduleUrl: [{ required: true, message: '请输入URL', trigger: 'blur' }],
        // moduleOrder: [
        //   { required: true, message: '请输入菜单顺序', trigger: 'blur' }
        // ]
      },
      fmenu: []
    }
  },
  /**
   * 创建完毕
   */

  created() {
    this.getdata()
    this.getmenu()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据
    getdata() {
      ModuleList()
        .then(res => {
          this.treeData = res.data
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单管理列表失败，请稍后再试！')
        })
    },
    // 添加
    addModule() {
        this.form.id = '',
        this.form.pid = '',
        this.form.moduleName = '',
        this.form.moduleUrl = '',
        this.form.moduleIcon = '',
        this.form.sort = '',
        this.form.moduleAlias = ''
    },
    // 获取父级菜单
    getmenu() {
      let parm = {
        pid: '0'
      }
      ModuleNodes(parm)
        .then(res => {
          this.fmenu = res.data
        })
        .catch(err => {
          this.loading = false
          this.$message.error('父级菜单列表获取失败，请稍后再试！')
        })
    },
    // 复选变单选
    // handleClick(data, checked, node) {
    //   if (checked) {
    //     this.$refs.tree.setCheckedNodes([])
    //     this.$refs.tree.setCheckedNodes([data])
    //     this.showdelete = true
    //   } else {
    //   }
    // },
    // 点击节点
    nodeclick(arr, node, self) {
      this.form.id = node.data.id
      this.form.moduleName = node.data.name
      this.form.moduleAlias = node.data.alias
      this.form.moduleUrl = node.data.url
      this.form.moduleIcon = node.data.icon
      this.form.sort = node.data.sort
      this.form.pid = node.data.pid
    },
    // 选中子节点，默认选中父节点
    // checkeTree (data) {
    //   let thisNode = this.$refs.tree.getNode(data.id) // 获取当前节点
    //   const keys = this.$refs.tree.getCheckedKeys() // 获取已勾选节点的key值
 
    //   if (thisNode.checked) { // 当前节点若被选中
    //     for (let i = thisNode.level; i > 1; i--) { // 判断是否有父级节点
    //       if (!thisNode.parent.checked) { // 父级节点未被选中，则将父节点替换成当前节点，往上继续查询，并将此节点key存入keys数组
    //         thisNode = thisNode.parent
    //         keys.push(thisNode.data.id)
    //       }
    //     }
    //   }
 
    //   this.$refs.tree.setCheckedKeys(keys) // 将所有keys数组的节点全选中
    // },
    // 保存菜单
    saveModule(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ModuleSave(this.form)
            .then(res => {
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
                this.getmenu()
              }else{
                this.$message({
                  type: 'info',
                  message: res.msg
              })
              }
            })
            .catch(err => {
              this.$message.error('菜单管理列表保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    deleteModule() {
      let menuId = this.form.id
      if(menuId.length <= 0){
        this.$message({
          type: 'warning',
          message: '没有选中菜单'
        })
        return false
      }
      if(this.form.pid == 0){
        this.$message({
          type: 'warning',
          message: '顶级菜单暂不能删除'
        })
        return false
      }
      this.$confirm('确定删除该菜单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const param = { menuId:menuId }
          ModuleDelete(param)
            .then(res => {
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
                this.getmenu()
              }else{
                this.$message({
                  type: 'warnimg',
                  message: res.msg
              })
              }
            })
            .catch(err => {
              this.$message.error('菜单管理列表保存失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  }
}
</script>

<style>
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
 }
</style>
 
 


// WEBPACK FOOTER //
// src/views/system/Module.vue